import React from 'react';
import { useNavigate } from 'react-router-dom';
import logo from "../../../assets/images/logo.png";
import './EventNotFound.scss';

const EventNotFound = () => {
  const navigate = useNavigate();

  return (
    <div className='EventNotFound'>
      <div style={{ width: '100%', height: '66px', backgroundColor: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <img src={logo} alt="Logo" style={{ height: '100%' }} />
      </div>
      <div className="content">
        <div className="emoji">🎭</div>
        <h1 className="title">Esse evento não existe mais</h1>
        <p className="message">
          Ops! Parece que este evento não está mais disponível.
        </p>
        <p className="submessage">
          Ele pode ter sido cancelado, encerrado ou removido pelo organizador.
        </p>
        <button className="home-button" onClick={() => navigate('/')}>
          Voltar para o início
        </button>
      </div>
    </div>
  );
}

export default EventNotFound;
